import styled from '../../../../lib/theme';

const CollectionFormStyle = styled('div')`
  button {
    border-radius: 24px;
    margin: 4px;
    color: ${({ theme }) =>
      theme.suggestedResponseColor || theme.primaryAccentColor} !important;
  }
  .k-form fieldset, .k-form-inline fieldset {
    margin: 0px;
    border-width: 0px;
  }
  .k-form, .k-form-inline {
    padding: 16px;
  }
`;

export default CollectionFormStyle;
